const STORAGE_KEY = 'recent-name-searches';
const MAX_RECENT = 5;

const normalize = name => (typeof name === 'string' ? name : '').trim();
const sameName = (a, b) => a.toLocaleLowerCase() === b.toLocaleLowerCase();

export function readRecentNameSearches(storage) {
  try {
    let parsed = JSON.parse(storage.get(STORAGE_KEY));
    return Array.isArray(parsed) ? parsed.map(normalize).filter(Boolean) : [];
  } catch {
    return [];
  }
}

export function rememberNameSearch(storage, name) {
  let trimmed = normalize(name);
  if (!trimmed) {
    return readRecentNameSearches(storage);
  }

  let next = [trimmed, ...readRecentNameSearches(storage).filter(n => !sameName(n, trimmed))].slice(
    0,
    MAX_RECENT
  );
  storage.set(STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function removeRecentNameSearch(storage, name) {
  let trimmed = normalize(name);
  let next = readRecentNameSearches(storage).filter(n => !sameName(n, trimmed));
  storage.set(STORAGE_KEY, JSON.stringify(next));
  return next;
}
